import React, { useState } from 'react';
import { useNavigate } from '@reach/router';

import ga from '~/utils/ga';
import apiCall, { LIVE_URL, TEST_URL } from '~/utils/apiCall';
import dabangBridge from '~/utils/bridge';

import useAuth from '~/hooks/useAuth';

import BG from '~/components/background';

import top from './images/top.png';
import bottom from './images/bottom.png';

import { Wrap, AgreeWrap, Label, Checkbox, Ul, BottomWrap } from './styled';

function Arrow({ fn }) {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" onClick={fn}>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path fill="#000" d="M0 0H40V40H0z" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000)"/>
              <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="4" d="M27 9L27 23 13 23" transform="translate(-391.000000, -2172.000000) translate(0.000000, 2172.000000) translate(391.000000, 0.000000) translate(20.000000, 16.000000) rotate(-315.000000) translate(-20.000000, -16.000000)"/>
          </g>
          </g>
        </g>
      </g>
  </svg>
  );
}

function HomeComponent(props) {
  const [agree, setAgree] = useState(false);
  const [open, setOpen] = useState(false);
  const [isSending, setSending] = useState(false);

  const navigate = useNavigate();

  const { authKey } = useAuth();

  const agreeText = [
    '1. 개인정보 수집 및 이용목적 : 당첨자 선정',
    '2. 수집하려는 개인정보의 항목 : 이름, 휴대폰번호',
    '3. 개인정보의 보유 및 이용 기간 : 당첨자 선정 후 3개월간 보관 후 파기',
    '4. 본 개인정보 제공에 동의를 거부할 권리가 있으며, 동의 거부 시 이벤트 참여가 제한됩니다.',
    '5. 제공해 주신 개인 정보는 이벤트 경품 발송 용도 외에는 활용하지 않습니다.',
  ];

  function openTerms(e) {
    e.preventDefault();
    setOpen(prev => !prev);
  }

  function close() {
    dabangBridge.android(call => {
      call.finishActivity();
    });

    dabangBridge.ios(call => {
      call.callHandler('iOS Echo', {
        cmd: 'finishActivity',
      });
    });
  }

  async function goQuiz() {
    if (isSending) return;

    if (!agree) return alert('본 이벤트는 개인정보 수집/이용 항목에 동의 후 참여가능 합니다.');

    setSending(true);

    try {
      const res = await apiCall.post(`${LIVE_URL}/api/v1/event/2022/bluemarble/auth`, { authKey });
      ga('DBTI', '동네찾아보기', '');
      const errorCode = [501, 502, 503, 504, 505, 506, 507, 508];

      setSending(false);

      if (!res) {
        alert('본 이벤트는 조기 마감되었습니다. 감사합니다.');
        close();

      } else {
        if (errorCode.includes(res.code)) {
          alert(res.msg);

          if (res.code === 501) {                   // 로그인 안되어 있는 경우 로그인 페이지로 이동하는 브릿지
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showLoginAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showLoginAndReload();
            });
            
          } else if (res.code === 502 || res.code === 508) {            // 본인인증 페이지로 이동
            dabangBridge.ios(call => {
              call.callHandler('ObjC Echo', {
                cmd: 'showAuthAndReload',
              });
            });
        
            dabangBridge.android(call => {
              console.log('android');
              call.showAuthAndReload();
            });
          }

        } else if (res.code === 200) {
          window.location.replace(`/2022/04/dbti/quiz/?auth_key=${authKey}`);
        }
      }

    } catch(err) {
      console.log(err);
      setSending(false);
      alert(err?.msg ?? '서버에러가 발생했습니다.');
    }
  }

  return (
    <Wrap>
      <BG width={710} height={3058} imgUrl={top} />
      <AgreeWrap>
        <Label isOpen={open}>
          <Checkbox type="checkbox" checked={agree} onChange={() => setAgree(prev => !prev)} />
          <p>개인정보 수집/이용에 대한 동의</p>
          <Arrow fn={openTerms} />
        </Label>
  
        {open && (
          <Ul>
            {agreeText.map((text, key) => (
              <li key={key}>{text}</li>
            ))}
          </Ul>
        )}
      </AgreeWrap>
      <BottomWrap>
        <button onClick={goQuiz} />
        <BG width={710} height={720} imgUrl={bottom} />
      </BottomWrap>
    </Wrap>
  );
}

export default HomeComponent;
